require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-jennersdorf-mogersdorf.json") })
        }
      }, "path---betreuungseinrichtungen-jennersdorf-mogersdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-jennersdorf-mogersdorf!./.cache/json/betreuungseinrichtungen-jennersdorf-mogersdorf.json
// module id = 916
// module chunks = 231608221292675